<!--<script>-->
<!--import { Bar, Doughnut, Pie } from 'vue-chartjs'-->
<!--import { base_url } from "../../http";-->

<!--export default {-->
<!--  extends: Doughnut,-->
<!--  name: "topProductsChart",-->
<!--  data() {-->
<!--    return {-->
<!--      loading: true,-->

<!--      chartdata: {-->
<!--        labels: [],-->
<!--        datasets: [{-->
<!--          label: 'Топ 5 товаров',-->
<!--          data: [],-->
<!--          backgroundColor: [-->
<!--            'rgba(255, 99, 132, 0.2)',-->
<!--            'rgba(54, 162, 235, 0.2)',-->
<!--            'rgba(255, 206, 86, 0.2)',-->
<!--            'rgba(75, 192, 192, 0.2)',-->
<!--            'rgba(153, 102, 255, 0.2)',-->
<!--            // 'rgba(255, 159, 64, 0.2)'-->
<!--          ],-->
<!--          borderColor: [-->
<!--            'rgba(255, 99, 132, 1)',-->
<!--            'rgba(54, 162, 235, 1)',-->
<!--            'rgba(255, 206, 86, 1)',-->
<!--            'rgba(75, 192, 192, 1)',-->
<!--            'rgba(153, 102, 255, 1)',-->
<!--            // 'rgba(255, 159, 64, 1)'-->
<!--          ],-->
<!--          borderWidth: 1-->
<!--        }]-->
<!--      },-->
<!--      options: {-->
<!--        responsive: true,-->
<!--        maintainAspectRatio: false,-->
<!--        // scales: {-->
<!--        //   yAxes: [{-->
<!--        //     ticks: {-->
<!--        //       beginAtZero: true-->
<!--        //     }-->
<!--        //   }]-->
<!--        // }-->
<!--      }-->


<!--    };-->
<!--  },-->

<!--  // Загружаем данные для таблицы-->
<!--  methods: {-->
<!--    fetchTopProducts: function() {-->
<!--      this.loading = true;-->
<!--      this.lastDraw++;-->
<!--      let url = `${base_url}/charts/top_products/`;-->
<!--      this.$http-->
<!--        .get(url, {-->
<!--          // params: this.fetchParams-->
<!--        })-->
<!--        .then(result => {-->
<!--          // if (result.data.draw === this.lastDraw) {-->
<!--          result.data.forEach(product=>{-->
<!--              this.chartdata.labels.push(product.name);-->
<!--              this.chartdata.datasets[0].data.push(product.total_sum);-->
<!--            });-->

<!--          this.renderChart(this.chartdata, this.options);-->
<!--          // this.data.top_products = result.data;-->
<!--          // this.totalRecords = result.data.count;-->
<!--          // }-->
<!--        })-->
<!--        .finally(() => {-->
<!--          this.loading = false;-->
<!--        });-->
<!--    },-->
<!--  },-->
<!--  mounted: function () {-->
<!--    this.fetchTopProducts();-->
<!--  }-->
<!--};-->
<!--</script>-->

<!--<style scoped>-->
<!--</style>-->


<template>

  <div class="demo-spin-article small-table">
    <Table
      :loading="loading"
      :columns="columns"
      :data="data"
      @on-sort-change="changeSorting"
      @on-selection-change="onSelectChange"
    ></Table>
  </div>

</template>

<script>

    import {base_url} from "../../http.js";

    import { formatShortText } from "../../base/base_func.js";
    import { BaseFormData } from "../../base/base_form_v2.js";
    let _app = BaseFormData();
    _app.name = "top_products";

    _app.data = function () {
        return {
            baseViewUrl: base_url + "/charts/top_products/",
            // baseViewUrl: base_url + "/catalog/products/",
            item_type: "catalog",
            loading: true,

            // Table settings
            columns: [
                {
                    title: "Наименование",
                    // width: 340,
                    key: "name",
                    render: (h, params) => {
                        // return h("span", {}, formatNumber(params.row.purchase) + ' ' + this.currency);
                        return h("span", {}, formatShortText(params.row.name));
                    }
                },

                {
                    title: "Цена",
                    width: 90,
                    // maxWidth: 140,
                    key: "average_price",
                    align: "center"
                },
                {
                    title: "Кол-во",
                    width: 90,
                    key: "total_count",
                    // width: 150,
                    align: "center",
                },
                {
                    title: "Прибыль",
                    // width: 60,
                    key: "profit",
                    // width: 100,
                    align: "center"
                },
            ],

            data: [],

            // Загружаем данные для таблицы

        }
    };

    _app.methods.getTopProducts = function() {
        const url = base_url + "/charts/top_products/";

        this.$http
            .get(url)
            .then(result => {
                this.data = result.data;
            })
    };



    _app.mounted = function() {
        this.getTopProducts();

    };



    export default _app;
</script>

<style>
  .small-table .ivu-table th, .small-table .ivu-table .ivu-table-row {
    font-size: 14px;
  }
  .small-table thead .ivu-table-cell {
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/apps/home/topProductsChart.vue